import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import KeyRoundedIcon from '@mui/icons-material/KeyRounded';
import SpeedRoundedIcon from '@mui/icons-material/SpeedRounded';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCarBattery } from '@fortawesome/free-solid-svg-icons'
import SensorDoorRoundedIcon from '@mui/icons-material/SensorDoorRounded';
import AcUnitRoundedIcon from '@mui/icons-material/AcUnitRounded';
import openDoor from '../../../../assets/abertura-da-porta-aberta.png'
import styles from './VehicleAllStateIcons.module.scss';
import { Button, Tooltip } from '@mui/material';



export const VehicleAllStateIcons = ({ numberOfEvents, driverAwareness, door, ignition, speed, battery, thermoKing, isAlarmActived }) => {
    return (
        <div className={styles.boxIcons}>
            <Tooltip title={driverAwareness === 0 && isAlarmActived > 0 ? "Botão de Ciência Não Pressionado" : ((numberOfEvents > 0 && isAlarmActived === 0) || (driverAwareness === 1 && isAlarmActived > 0)) ? "Motorista Ciente" : "Sem Alarmes para Ciência"}>
                <WarningAmberRoundedIcon
                    className={`${styles.driverAwarenessIcon} ${driverAwareness === 0 && isAlarmActived > 0 ? styles.driverNonAware : ((numberOfEvents > 0 && isAlarmActived === 0) || (driverAwareness === 1 && isAlarmActived > 0)) ? styles.driverAware : styles.driverDontNeedToBeAware}`}
                />
            </Tooltip>
            <Tooltip title={thermoKing === "OFF" ? "Climatização Desligada" : thermoKing === "ON" ? "Climatização Ligada" : "Climatização Desligada !!"}>
                <AcUnitRoundedIcon
                    className={`${styles.thermoKingIcon} ${thermoKing === "OFF" ? styles.thermoKingOFF : thermoKing === "ON" ? styles.thermoKingON : styles.thermoKingOFFatention}`}
                />
            </Tooltip>

            <Tooltip title={door ? "Porta Fechada" : "Porta Aberta"}>
                {door ?
                    <SensorDoorRoundedIcon
                        className={`${styles.doorIcon} ${door ? styles.closedDoor : styles.openDoor}`}
                    />
                    :
                    <img
                        src={openDoor}
                        alt="Ícone"
                        style={{
                            height: "22px",
                            width: "22px",
                        }}
                    />
                }

            </Tooltip>
            <Tooltip title={ignition ? "Ignição Ligada" : "Ignição Desligada"}>
                <KeyRoundedIcon
                    className={`${styles.ignitionIcon} ${ignition ? styles.ignitionOn : styles.ignitionOff}`}
                />
            </Tooltip>
            <Button
                className={styles.speedContainer}
                variant="text"
                startIcon={<SpeedRoundedIcon className={styles.speedIcon} />}
            >
                <span className={styles.speedText}>{speed + ' km/h'}</span>
            </Button>
            <Button
                className={styles.batteryContainer}
                variant="text"
                startIcon={<FontAwesomeIcon icon={faCarBattery} className={styles.batteryIcon} />}
            >
                <span className={styles.batteryText}>{battery + 'V'}</span>
            </Button>
        </div>
    );
}